import React, { Component } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";

class ChangeDistributorStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status:
        this.props.distributorDetails && this.props.distributorDetails.item
          ? this.props.distributorDetails.item.status
          : null,
    };
  }

  Submit = () => {
    let value = this.props.distributorDetails;
    this.props.ChangeStatus(value);
    this.props.closeModel();
    this.props.resetPage();
  };

  render() {
    const data =
      this.props.distributorDetails && this.props.distributorDetails.item
        ? this.props.distributorDetails.item
        : null;

    return (
      <div>
        <div className="userModalDiv">
          <Modal
            show={this.props.show}
            onHide={this.props.closeModel}
            animation={false}
            size="md"
            backdrop="static"
            centered={true}
          >

            {data !== null && data.status === "suspended" ? (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>Change the distributor profile status to "Active" ?</b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.closeModel()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            ) : (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>Suspend the distributor profile?</b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "30px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.closeModel()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            )}
          </Modal>
        </div>
      </div>
    );
  }
}

export default ChangeDistributorStatus;
